<template>
  <div>
    <section class="hero">
      <div class="hero-body">
        <div class="container">
          <h1 class="title has-text-centered">
            チラシデータ登録
          </h1>
        </div>
      </div>
    </section>
    <section>
      <div class="columns">
        <section class="column is-half is-offset-one-quarter">
          <b-field
            label=""
            :type="'is-info'"
            :message="'*がついている項目は必須項目です。'"
            class="has-text-right"
          />

          <b-field
            label="スポンサー* （ビューアーには表示されません）"
            :type="errors.sponsor ? 'is-danger' : ''"
            :message="errors.sponsor ? errors.sponsor : ''"
          >
            <b-input v-model="form.sponsor"></b-input>
          </b-field>

          <b-field
            label="タイトル*"
            :type="errors.title ? 'is-danger' : ''"
            :message="errors.title ? errors.title : ''"
          >
            <b-input v-model="form.title"></b-input>
          </b-field>

          <b-field
            label="お問い合わせ先*"
            :type="errors.contact ? 'is-danger' : ''"
            :message="errors.contact ? errors.contact : ''"
          >
            <b-input
              v-model="form.contact"
              type="textarea"
            ></b-input>
          </b-field>

          <b-field
            label="掲載期間*"
            :type="errors.publicationPeriod ? 'is-danger' : ''"
            :message="
                            errors.publicationPeriod
                                ? errors.publicationPeriod
                                : ''
                        "
          >
            <b-datepicker
              placeholder="Click to select..."
              icon="calendar-today"
              :month-names="month_names"
              :day-names="day_names"
              range
              :years-range="yearRange"
              @change-year="updateYearRange"
              v-model="form.publicationPeriod"
            >
            </b-datepicker>
          </b-field>

          <b-field
            label="住所*"
            :type="errors.address ? 'is-danger' : ''"
            :message="errors.address ? errors.address : ''"
          >
            <b-input
              v-model="form.address"
              type="textarea"
            ></b-input>
          </b-field>

          <b-field
            label="電話番号*"
            :type="errors.tel ? 'is-danger' : ''"
            :message="errors.tel ? errors.tel : ''"
          >
            <b-input
              v-model="form.tel"
              type="textarea"
            ></b-input>
          </b-field>

          <b-field
            label="ホームページ*"
            :type="errors.website ? 'is-danger' : ''"
            :message="errors.website ? errors.website : ''"
          >
            <b-input
              v-model="form.website"
              type="textarea"
            ></b-input>
          </b-field>

          <b-field
            label="チラシ画像*（.jpg .gif .png のいずれかのファイル形式）"
            :type="errors.images ? 'is-danger' : ''"
            :message="errors.images ? errors.images : ''"
          />
          <div
            v-for="i in [0, 1, 2, 3, 4, 5, 6]"
            :key="i"
          >
            <b-field
              grouped
              class="m-b-10"
            >
              <div class="p-t-5 p-b-5 m-r-20 area-block">
                <p>チラシ画像 {{ i + 1 }}</p>
              </div>
              <b-button
                class="button m-r-10"
                @click="imageModal(form.images[i])"
                v-if="form.images[i]"
              >
                確認
              </b-button>
              <label
                :for="files[i]"
                class="button m-r-10 is-success"
                v-if="
                                    (i == 0 || form.images[i - 1]) &&
                                        !form.images[i]
                                "
              >
                追加
                <input
                  type="file"
                  @change="upload($event, i, false)"
                  :id="files[i]"
                  style="display:none;"
                />
              </label>
              <b-button
                class="is-danger"
                v-if="form.images[i]"
                @click="remove(i, false)"
              >
                削除
              </b-button>
            </b-field>
          </div>
          <b-field
            grouped
            class="m-b-10"
          >
            <div class="p-t-5 m-r-50 area-block">
              <p>ロゴ画像</p>
            </div>
            <b-button
              class="button m-r-10"
              @click="imageModal(form.logoImage)"
              v-if="form.logoImage"
            >
              確認
            </b-button>
            <label
              :for="'logofile'"
              class="button m-r-10 is-success"
              v-if="!form.logoImage"
            >
              追加
              <input
                type="file"
                @change="upload($event, null, true)"
                :id="'logofile'"
                style="display:none;"
              />
            </label>
            <b-button
              class="is-danger"
              v-if="form.logoImage"
              @click="remove(null, true)"
            >
              削除
            </b-button>
          </b-field>

          <b-field
            label=""
            class="m-t-20 is-pulled-right"
          >
            <router-link to="/flyers">
              <b-button class="is-medium">戻る</b-button>
            </router-link>
            <b-button
              :disabled="loading"
              @click="createFlyer"
              class="m-l-20 is-primary is-medium"
            >
              登録
            </b-button>
          </b-field>
        </section>
      </div>
    </section>
  </div>
</template>

<script>
import { v4 as uuid } from "uuid";
import { API, graphqlOperation, Storage } from "aws-amplify";
import { createFlyer as createFlyerMutation } from "@/graphql/mutations";
import { FlyerStatus } from "@/models";
import settings from "@/constants";
import { validate_data, date_check, upload_image, remove_image } from "@/utils";

export default {
  name: "CreateFlyer",
  data: function() {
    return {
      loading: false,
      form: {
        id: uuid(),
        title: "",
        contact: "",
        address: "",
        tel: "",
        website: "",
        permalink: "",
        logoImage: "",
        images: [],
        sponsor: "",
        publicationPeriod: [],
        status: null
      },
      errors: {},
      files: [],
      yearRange: [-100, 100]
    };
  },
  computed: {
    month_names() {
      return settings.month_names;
    },
    day_names() {
      return settings.day_names;
    }
  },
  methods: {
    createFlyer() {
      this.errors = validate_data(this.form);
      if (Object.keys(this.errors).length) {
        this.$buefy.toast.open({
          message: "チラシを登録できませんでした。入力内容を確認してください。",
          type: "is-danger"
        });

        return;
      }

      if (date_check(this.form)) {
        if (!confirm("掲載期間中なのですぐに公開されます。よろしいですか？")) {
          return;
        }
      }

      this.loading = true;
      return API.graphql(
        graphqlOperation(createFlyerMutation, {
          input: {
            id: this.form.id,
            title: this.form.title,
            contact: this.form.contact,
            startDate: this.form.publicationPeriod[0],
            endDate: this.form.publicationPeriod[1],
            address: this.form.address,
            tel: this.form.tel,
            website: this.form.website,
            permalink:
              this.form.permalink.length > 0
                ? this.form.permalink
                : this.form.id,
            sponsor: this.form.sponsor.length > 0 ? this.form.sponsor : "",
            images: this.form.images,
            logoImage:
              this.form.logoImage.length > 0 ? this.form.logoImage : null,
            status: FlyerStatus.TO_BE_CREATED
          }
        })
      )
        .then(() => {
          this.loading = false;
          this.$buefy.toast.open({
            message: "チラシを作成しました",
            type: "is-success"
          });

          this.$router.push({
            path: "/"
          });
        })
        .catch(err => {
          console.log(err);
          this.loading = false;
          this.$buefy.toast.open({
            message:
              "チラシの登録に失敗しました。管理者にお問い合わせください。",
            type: "is-danger"
          });
        });
    },
    async upload(e, idx, isLogo) {
      let prefix = this.form.id + "/";
      if (isLogo) {
        prefix = prefix + "_logo";
      }

      const allImages = Object.assign([], this.form.images);
      allImages.push(this.form.logoImage);
      const result = await upload_image(
        e,
        prefix,
        allImages.filter(v => v)
      );

      if (result.result) {
        if (isLogo) {
          this.form.logoImage = result.data;
        } else {
          this.$set(this.form.images, idx, result.data);
        }

        this.$buefy.toast.open({
          message: result.message,
          type: "is-success"
        });
      } else {
        this.$buefy.toast.open({
          message: result.message,
          type: "is-danger"
        });
      }
    },
    async remove(idx, isLogo) {
      if (!confirm("削除します。よろしいですか?")) {
        this.$buefy.toast.open({
          message: "キャンセルしました",
          type: "is-info"
        });
        return;
      }

      let key = this.form.images[idx];
      if (isLogo) {
        key = this.form.logoImage;
      }

      const result = await remove_image(key);

      if (result.result) {
        if (isLogo) {
          this.form.logoImage = null;
        } else {
          this.$set(this.form.images, idx, null);
        }

        this.$buefy.toast.open({
          message: result.message,
          type: "is-success"
        });
      } else {
        this.$buefy.toast.open({
          message: result.message,
          type: "is-danger"
        });
      }
    },
    imageModal(key) {
      Storage.get(key)
        .then(result => {
          this.$buefy.modal.open(
            '<div class="has-text-centered"><img src="' + result + '"></div>'
          );
        })
        .catch(err => {
          console.log(err);
          this.$buefy.toast.open({
            message: "画像の取得に失敗しました",
            type: "is-danger"
          });
        });
    },
    updateYearRange(selectedYear) {
      var today = new Date();
      var year = today.getFullYear();

      this.yearRange = [
        -100 + (year - selectedYear),
        100 + (year - selectedYear)
      ];
    }
  }
};
</script>

<style scoped>
.area-block {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  justify-items: center;
}
</style>
